import { render } from "./comment.vue?vue&type=template&id=2805c402&scoped=true&ts=true"
import script from "./comment.vue?vue&type=script&lang=ts"
export * from "./comment.vue?vue&type=script&lang=ts"

import "./comment.vue?vue&type=style&index=0&id=2805c402&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2805c402"]])

export default __exports__